import { Component, EventEmitter, Output } from '@angular/core';
import { NgForOf, NgIf } from "@angular/common";
import { EditorModule } from "primeng/editor";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from 'primeng/table';
import { TagModule } from "primeng/tag";
import { Button } from "primeng/button";
import { TaskService } from "../../sipo/services/task.service";
import { TaskStatusIconComponent } from "../../shared/components/task-status-icon/task-status-icon.component";
import { AccordionModule } from "primeng/accordion";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {ITask} from "../shared/models/task.model";

@Component({
    selector: 'app-task-details',
    standalone: true,
    imports: [
        NgForOf,
        NgIf,
        EditorModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        TagModule,
        Button,
        TaskStatusIconComponent,
        AccordionModule,
        TranslateModule
    ],
    templateUrl: './task-details.component.html',
    styleUrl: './task-details.component.scss'
})
export class TaskDetailsComponent {

    @Output() taskTitle = new EventEmitter<string>();
    isWriteResultOpen: boolean = false;
    isCommentOpen: boolean = false;
    resultText!: string;
    commentText!: string;
    files: string[] = ['file-1.pdf', 'file-2.pdf'];
    tasks!: ITask[];
    accordionHeader: string = 'Expand'

    constructor(private taskService: TaskService, private translateService: TranslateService) {
        this.tasks = taskService.getTasksWithSubtasksData() as ITask[];
    }

    ngOnInit() {
        this.taskTitle.emit(this.tasks[0].no + ' ' + this.tasks[0].title);
        this.translateService.get('task.expand').subscribe(data => {
            this.accordionHeader = data;
        })
    }

    comments: { user: string, comment: string, date: string }[] = [
        {
            user: 'Janakan K',
            comment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum et ex labore libero molestias nam nisi nobis pariatur placeat quo, quos rem reprehenderit rerum, sit tempore ut voluptatum. Commodi, facere.',
            date: '10.05.2024 12:24:05'
        },
        {
            user: 'Hans H',
            comment: 'placeat quo, quos rem reprehenderit rerum, sit tempore ut voluptatum. Commodi, facere amet, consectetur adipisicing elit.',
            date: '05.08.2024 11:44:25'
        },
        {
            user: 'Helena B',
            comment: 'Labore libero molestias nam nisi nobis pariatur placeat quo, quos rem reprehenderit rerum, sit tempore ut voluptatum. Commodi, facere.',
            date: '23.11.2024 08:20:11'
        }
    ]

    toggleAccordionHeader(): void {
        if (this.accordionHeader === 'Expand') {
            this.translateService.get('task.collapse').subscribe(data => {
                this.accordionHeader = data;
            })
        } else {
            this.translateService.get('task.expand').subscribe(data => {
                this.accordionHeader = data;
            })
        }
    }

    openResult(): void {
        this.isWriteResultOpen = true;
    }

    openComment(): void {
        this.isCommentOpen = true;
    }

    protected readonly Comment = Comment;
}
